import React, { useEffect, useState } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import AddWebsiteModalForm from "../Website/AddWebsiteModelForm";
import AdstxtModalForm from "../Website/AdstxtWebsite";
import WebsiteApiService from '../../ApiServices/WebsiteApiService/WebsiteApiService';
import AppApiService from '../../ApiServices/WebsiteApiService/AppApiService';
import adsTxtApiService from '../../ApiServices/AdsTxtApiService/AdTxtApiService';
import { useAuth } from "../Auth/AuthContext";
import { useNavigate } from "react-router-dom";

export default function TextCard() {
    const { authState } = useAuth();
    const user = authState.user;
    const role = authState.roles;
    const admin = role === "Admin";

    const [openModal, setOpenModal] = useState(false);
    const [openAdsModal, setOpenAdsModal] = useState(false);
    const [websiteDataArray, setWebsiteDataArray] = useState([]);
    const [appDataArray, setAppDataArray] = useState([]);
    const [loading, setLoading] = useState(true); // Loading state

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });

        const fetchData = async () => {
            try {
                const websiteData = admin
                    ? await WebsiteApiService.Get()
                    : await WebsiteApiService.GetAllWebByUserId(user.id);

                const appData = admin
                    ? await AppApiService.Get()
                    : await AppApiService.GetAllAppByUserId(user.id);

                setWebsiteDataArray(Array.isArray(websiteData.data) ? websiteData.data : [websiteData.data]);
                setAppDataArray(Array.isArray(appData.data) ? appData.data : [appData.data]);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [admin, user.id]);

    const handleDownload = async () => {
        await adsTxtApiService.DownloadAdFile("AdTxt");
    };
    const navigate = useNavigate();
    const handleAnalytics = () => {
        navigate("/analytics");
    };

    return (
        <div data-aos="fade-up" data-aos-delay="100" className="bg-white shadow-md rounded-lg p-6 flex flex-col">
            <div className="flex justify-between mb-4">
                <div className="flex-1">
                    {/* Show loader when loading */}
                    {loading ? (
                        <p className="text-yellow-500 font-semibold">Loading...</p>
                    ) : (
                        <>
                            {(websiteDataArray.length === 0 && appDataArray.length === 0) && (
                                <p className="text-yellow-500 font-semibold">
                                    Please add your website or apps
                                </p>
                            )}
                            <div className="flex items-center mb-2">
                                <svg className="w-5 h-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                                </svg>
                                <p className="text-green-500 font-semibold">Yes, there is no violation.</p>
                            </div>
                            <p className="text-sm text-gray-600 mb-2">Great going gaming. We did not find any policy violation.</p>
                            <p className="text-sm text-gray-500">No privacy violation found</p>
                        </>
                    )}
                </div>
                <div className="ml-4">
                    <a href="#" className="text-blue-500 hover:underline">Open Policy Center</a>
                </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
                <button
                    onClick={handleAnalytics}
                    className="w-full flex items-center justify-center text-blue-500 border border-blue-500 hover:bg-blue-500 hover:text-white transition-colors duration-300 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2">
                    Revenue
                </button>
                <button
                    onClick={handleAnalytics}
                    className="w-full flex items-center justify-center text-blue-500 border border-blue-500 hover:bg-blue-500 hover:text-white transition-colors duration-300 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2">
                    View Detailed Analytics
                </button>
                <button
                    onClick={handleDownload}
                    className="w-full flex items-center justify-center text-yellow-500 border border-yellow-500 hover:bg-yellow-500 hover:text-white transition-colors duration-300 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-sm px-4 py-2">
                    Ads.txt/App-ads.txt
                </button>
                <button onClick={() => setOpenModal(true)} className="w-full flex items-center justify-center text-yellow-500 border border-yellow-500 hover:bg-yellow-500 hover:text-white transition-colors duration-300 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-sm px-4 py-2">
                    Add App/Website
                </button>
            </div>

            <AddWebsiteModalForm isOpen={openModal} closeModal={() => setOpenModal(false)} />
            <AdstxtModalForm isOpen={openAdsModal} closeModal={() => setOpenAdsModal(false)} />
        </div>
    );
}
